import { z } from "zod";

const LogicalOperatorValues = ["AND", "OR"] as const;
const LogicalOperatorSchema = z.enum(LogicalOperatorValues);
export type LogicalOperator = z.infer<typeof LogicalOperatorSchema>;
export const LogicalOperator = LogicalOperatorSchema.enum;

const ComparatorValues = [
  "EQUALS",
  "NOT_EQUALS",
  "GREATER_THAN",
  "LESS_THAN",
  "GREATER_THAN_OR_EQUAL",
  "LESS_THAN_OR_EQUAL",
  "IN",
  "NOT_IN",
  "LIKE",
  "CONTAINS_ALL",
] as const;

const ComparatorSchema = z.enum(ComparatorValues);
export type Comparator = z.infer<typeof ComparatorSchema>;
export const Comparator = ComparatorSchema.enum;

export const ComparitorToReadable: Record<Comparator, string> = {
  EQUALS: "is",
  NOT_EQUALS: "is not",
  GREATER_THAN: "is greater than",
  LESS_THAN: "is less than",
  GREATER_THAN_OR_EQUAL: "is greater than or equal to",
  LESS_THAN_OR_EQUAL: "is less than or equal to",
  IN: "is one of",
  NOT_IN: "is not one of",
  LIKE: "is like",
  CONTAINS_ALL: "is all of",
};

export const ComparatorsBySelectionCount = {
  single: [Comparator.EQUALS],
  multiple: [Comparator.IN, Comparator.CONTAINS_ALL],
} as const satisfies Record<string, readonly Comparator[]>;

export const MySqlValueValues = ["NULL", "NOW", "TRUE", "FALSE"] as const;
const MySqlValueSchema = z.enum(MySqlValueValues);
export type MySqlValue = z.infer<typeof MySqlValueSchema>;
export const MySqlValue = MySqlValueSchema.enum;

export const SortDefinitionSchema = z.object({
  sort: z.array(
    z.object({
      field: z.string(),
      direction: z.enum(["ASC", "DESC"]),
    }),
  ),
});
export type SortDefinition = z.infer<typeof SortDefinitionSchema>;

export const ConditionSchema = z.object({
  field: z.string(),
  value: z.string().or(z.number()).or(z.boolean()).or(z.null()).or(z.date()).or(z.array(z.string())),
  comparator: ComparatorSchema,
});
export type Condition = z.infer<typeof ConditionSchema>;

const BaseDefinitionSchema = z.object({
  operator: LogicalOperatorSchema,
});

export interface Definition {
  operator: LogicalOperator;
  conditions: (Definition | Condition)[];
}

export const DefinitionSchema: z.ZodType<Definition> = BaseDefinitionSchema.extend({
  conditions: z.lazy(() => z.array(z.union([DefinitionSchema, ConditionSchema]))),
});
